import { BASE_URLS } from "../config/urls";
import { News } from "../models/News";

export class NewsService {
    async getAll(): Promise<News[]> {
        const resp = await fetch(`${BASE_URLS.api}/news`, {
            headers: { Accept: "application/json" },
        });

        if (!resp.ok) {
            throw new Error("Не удалось загрузить новости");
        }

        const data = await resp.json();

        return data.map(
            (n: any) =>
                new News(
                    n.id,
                    n.title,
                    n.photoUrl,
                    n.shortDescription,
                    n.description,
                    new Date(n.dateCreated)
                )
        );
    }

    async getById(id: number): Promise<News> {
        const res = await fetch(`${BASE_URLS.api}/news/${id}`);
        if (!res.ok) throw new Error("Новость не найдена");

        const n = await res.json();
        return new News(
            n.id,
            n.title,
            n.photoUrl,
            n.shortDescription,
            n.description,
            new Date(n.dateCreated)
        );
    }
}
